/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoDomandaDTOProfiloAgid =
  (typeof EnumTipoDomandaDTOProfiloAgid)[keyof typeof EnumTipoDomandaDTOProfiloAgid];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaDTOProfiloAgid = {
  AGID_SUAP: 'AGID_SUAP',
  AGID_SUE: 'AGID_SUE',
  NESSUNO: 'NESSUNO',
} as const;
